module.exports = __webpack_public_path__ + "img/call.9fcc9fe5.svg";